import { Button, Modal } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { MdOutlineSpeed } from "react-icons/md";
import { AiOutlineClose } from "react-icons/ai";

export default function UsageLimit() {
    const { resource } = useParams<{ resource: 'follow' | 'post' }>();
    const { push, goBack } = useHistory()

    return <Modal show fullscreen size="lg">
        <div className="position-relative">
            <div className="r-5 t-5 cursor-pointer position-absolute" onClick={() => goBack()}>
                <AiOutlineClose size={25} />
            </div>
        </div>
        <div className="container pd-20">
            <div className="text-center">
                <MdOutlineSpeed size={90} color='#FDD835' />

                <h1>Limite atingido!</h1>
                <p className="tx-16">{getLimitMainText(resource)}</p>

                <div className="row pd-t-10q pd-b-10">
                    <div className="col-12">
                        <Button className="rounded-button" variant="success" onClick={() => {
                            return push('/billing');
                        }}>
                            Atualizar plano
                        </Button>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <Button className="rounded-button" variant="secondary" onClick={() => goBack()}>
                            Fechar
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </Modal >
}

function getLimitMainText(resource: string) {
    if (resource === 'follow') {
        return 'O máximo de ativos que você pode seguir foi atingido, sem problemas, você pode deixar de seguir alguns ativos que não curte mais ou você pode escolher um plano com um limite maior e que atenda todas suas demandas.'
    } else if (resource === 'analysis') {
        return 'O máximo de análises que você pode fazer foi mensalmente atingido, esse numero máximo de análises é zerado todos os meses, porém caso você queira um limite maior, você pode escolher um plano com um limite maior.'
    } else if (resource === 'refresh-wallet') {
        return 'O número máximo de análises de carteira do seu plano foi alcançado, esse numero é zerado todos os meses, você também pode atualizar seu plano para obter um maior limite.';
    }

    return 'O recurso que você tentou acessar chegou ao limite do seu plano atual, você pode escolher um plano com limite maior e desbloquear essa funcionalidade.'
}
